import { bool, number, oneOfType, string } from 'prop-types';
import React from 'react';

export default function PageNavCurPageIndicator({ curRange, nextRange, totalCount, resourceType, noStyle }) {
    return (<>
    </>);
}

PageNavCurPageIndicator.propTypes = {
    curRange: oneOfType([number, string]),
    nextRange: oneOfType([number, string]),
    totalCount: oneOfType([number, string]),
    resourceType: string,
    noStyle: bool,
};